<script setup lang="ts">
const props = defineProps({ blok: Object })

const visibleRef = ref(false)
const indexRef = ref(0)

const imgs = computed(() => {
    return props.blok?.images.map((item) => ({
        src: item.filename,
        title: item.filename,
    }))
})

const showImg = (index: number) => {
    indexRef.value = index
    visibleRef.value = true
}
const onHide = () => (visibleRef.value = false)
</script>

<template>
    <section class="section">
        <UiContainer>
            <header class="mb-20 global-text">
                <h2>{{ blok?.title }}</h2>
            </header>
            <div class="grid grid-cols-2 gap-12 max-[641px]:grid-cols-1 max-[641px]:gap-x-0 max-[641px]:gap-y-10">
                <template
                    v-for="(item, index) in props.blok?.images"
                    :key="item.filename"
                >
                    <div v-if="item.filename">
                        <div class="group aspect-video rounded-[40px] overflow-hidden relative">
                            <img
                                :src="item.filename"
                                alt="image"
                                class="w-full h-full object-cover cursor-pointer"
                                @click="() => showImg(index)"
                            >
                            <div class="absolute top-0 left-0 w-full h-full bg-black/50 flex items-center justify-center pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                <UIcon
                                    name="i-heroicons-magnifying-glass"
                                    class="text-white fs-2xl"
                                />
                            </div>
                            <div class="absolute bottom-2 right-4  bg-black/50 rounded-md text-white fs-md px-1.5 font-eb-garamond flex items-center justify-center pointer-events-none">
                                <p>{{ item.copyright }}</p>
                            </div>
                        </div>
                        <div class="mt-4">
                            <a
                                :href="item.filename"
                                download
                                class="group flex items-center gap-2 font-eb-garamond text-chsc-indigo-500 font-semibold fs-2xl"
                                target="_blank"
                            >
                                <span class="group-hover:underline">{{ blok?.download_label }}</span>
                                <UIcon
                                    name="i-heroicons-arrow-down-tray"
                                    class=""
                                />
                            </a>
                        </div>
                    </div>
                </template>
            </div>
        </UiContainer>
        <VueEasyLightbox
            :visible="visibleRef"
            :imgs="imgs"
            :index="indexRef"
            @hide="onHide"
        />
    </section>
</template>
